export const REQUEST_USER_SESSION = 'REQUEST_USER_SESSION';
export const RECEIVE_IDENTIFIED_USER = 'RECEIVE_IDENTIFIED_USER';
export const RECEIVE_UNIDENTIFIED_USER = 'RECEIVE_UNIDENTIFIED_USER';

export const SHOW_SIGN_IN_MODAL = 'SHOW_SIGN_IN_MODAL';
export const HIDE_SIGN_IN_MODAL = 'HIDE_SIGN_IN_MODAL';
export const SHOW_EMAIL_VERIFICATION = 'SHOW_EMAIL_VERIFICATION';
export const SHOW_FIRST_SIGN_IN = 'SHOW_FIRST_SIGN_IN';
export const SHOW_SIGN_UP = 'SHOW_SIGN_UP';
export const SHOW_SIGN_IN = 'SHOW_SIGN_IN';
export const SHOW_FORGOT_PASSWORD = 'SHOW_FORGOT_PASSWORD';
export const HIDE_FORGOT_PASSWORD = 'HIDE_FORGOT_PASSWORD';
export const SHOW_EMAIL_SENT = 'SHOW_EMAIL_SENT';

export const SUBMITTING_EMAIL_VERIFICATION = 'SUBMITTING_EMAIL_VERIFICATION';
export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND';
export const RESET_EMAIL_VERIFICATION = 'RESET_EMAIL_VERIFICATION';

export const SUBMITTING_FIRST_SIGN_IN = 'SUBMITTING_FIRST_SIGN_IN';
export const REQUEST_FIRST_SIGN_IN = 'REQUEST_FIRST_SIGN_IN';
export const FIRST_SIGN_IN_SUCCESS = 'FIRST_SIGN_IN_SUCCESS';
export const FIRST_SIGN_IN_FAILURE = 'FIRST_SIGN_IN_FAILURE';
export const RESET_FIRST_SIGN_IN = 'RESET_FIRST_SIGN_IN';

export const SUBMITTING_SIGN_IN = 'SUBMITTING_SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const RESET_SIGN_IN = 'RESET_SIGN_IN';

export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';
export const RESET_SIGN_UP = 'RESET_SIGN_UP';

export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD';

export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE';
export const REMOVE_ACCOUNT_IMAGE = 'REMOVE_ACCOUNT_IMAGE';


export const REQUEST_CUSTOMER_HISTORY = 'REQUEST_CUSTOMER_HISTORY';
export const RECEIVE_CUSTOMER_HISTORY = 'RECEIVE_CUSTOMER_HISTORY';

export const REQUEST_CUSTOMER_DRAFTS = 'REQUEST_CUSTOMER_DRAFTS';
export const RECEIVE_CUSTOMER_DRAFTS = 'RECEIVE_CUSTOMER_DRAFTS';

export const SIGN_UP_BUSINESS_SUCCESS = 'SIGN_UP_BUSINESS_SUCCESS';
export const SIGN_UP_BUSINESS_FAILURE = 'SIGN_UP_BUSINESS_FAILURE';
export const RESET_SIGN_UP_BUSINESS = 'RESET_SIGN_UP_BUSINESS';

export const FAILURE_QUOTATIONS = 'FAILURE_QUOTATIONS';
export const RECEIVE_QUOTATIONS = 'RECEIVE_QUOTATIONS';
export const REQUEST_QUOTATIONS = 'REQUEST_QUOTATIONS';
export const UPDATE_QUOTATIONS_FILTERS = 'UPDATE_QUOTATIONS_FILTERS';
export const UNLOAD_QUOTATIONS = 'UNLOAD_QUOTATIONS';

export const REQUEST_INVOICES = 'REQUEST_INVOICES';
export const RECEIVE_INVOICES = 'RECEIVE_INVOICES';
export const UPDATE_INVOICES_FILTERS = 'UPDATE_INVOICES_FILTERS';
export const FAILURE_INVOICES = 'FAILURE_INVOICES';
export const UNLOAD_INVOICE = 'UNLOAD_INVOICE';


export const FAILURE_RESERVATIONS = 'FAILURE_RESERVATIONS';
export const RECEIVE_RESERVATIONS = 'RECEIVE_RESERVATIONS';
export const REQUEST_RESERVATIONS = 'REQUEST_RESERVATIONS';
export const UPDATE_RESERVATIONS_FILTERS = 'UPDATE_RESERVATION_FILTERS';
export const UNLOAD_RESERVATIONS = 'UNLOAD_RESERVATIONS';
